import React, { forwardRef, useRef } from 'react';

import { Box } from '@chakra-ui/react';
import { HistogramChart } from '@mesh.ai/rabbit';

import { modifyString, StringModifier } from 'constants/copyHelpers';
import { isMobileView } from 'constants/isMobileView';

import ChartContainer from '../../ChartContainer/ChartContainer';

const GoalsOwnedChart = forwardRef<
  typeof HistogramChart,
  {
    chartData: [];
    pluralKeyResultsName: string;
  }
>(({ chartData, pluralKeyResultsName }, ref) => (
  <HistogramChart
    tooltipTitle={`${pluralKeyResultsName} Ownership Distribution`}
    xAxisLabel={`${pluralKeyResultsName} count`}
    yAxisLabel="Distinct count of Employees"
    data={chartData}
    integerBins
    integerYAxis
    // @ts-expect-error ref mismatch
    ref={ref}
  />
));

const CheckInChart = forwardRef<
  typeof HistogramChart,
  {
    chartData: [];
    pluralKeyResultsName: string;
  }
>(({ chartData, pluralKeyResultsName }, ref) => (
  <HistogramChart
    tooltipTitle={`${pluralKeyResultsName} Check-in Distribution`}
    xAxisLabel="Count of checkins"
    yAxisLabel="Distinct count of Employees"
    data={chartData}
    integerBins
    integerYAxis
    // @ts-expect-error ref mismatch
    ref={ref}
  />
));

interface Props {
  goalsOwnedChartData: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rowData: Array<any>;
  };
  keyResultsName: string;
}

const GroupByIndividualGraphs = ({ goalsOwnedChartData, keyResultsName }: Props) => {
  const goalOwnerChartRef = useRef();
  const checkInChartRef = useRef();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return (
    <>
      {!isMobileView() && (
        <Box display="flex" gap="16px">
          <ChartContainer
            chartData={goalsOwnedChartData}
            chartRef={goalOwnerChartRef}
            chartTitle={`${modifyString(keyResultsName, StringModifier.TITLE_CASE)} Ownership Distribution`}
            containerProps={{ width: 'calc(50% - 8px)' }}
          >
            <GoalsOwnedChart
              //   @ts-expect-error data type yet to be defined
              chartData={goalsOwnedChartData?.rowData?.map((data) => data?.keyResultCount || 0) || []}
              pluralKeyResultsName={modifyString(keyResultsName, StringModifier.PLURAL_TITLE_CASE)}
              keyResultsName={modifyString(keyResultsName, StringModifier.TITLE_CASE)}
            />
          </ChartContainer>
          <ChartContainer
            chartData={goalsOwnedChartData}
            chartRef={checkInChartRef}
            chartTitle={`${modifyString(keyResultsName, StringModifier.TITLE_CASE)} Check-in Distribution`}
            containerProps={{ width: 'calc(50% - 8px)' }}
          >
            <CheckInChart
              //   @ts-expect-error data type yet to be defined
              chartData={goalsOwnedChartData?.rowData?.map((data) => data?.totalCheckIns || 0) || []}
              pluralKeyResultsName={modifyString(keyResultsName, StringModifier.PLURAL_TITLE_CASE)}
              keyResultsName={modifyString(keyResultsName, StringModifier.TITLE_CASE)}
            />
          </ChartContainer>
        </Box>
      )}
    </>
  );
};

export { GroupByIndividualGraphs };
